import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './PlayerAvatar.css';

/**
 * Player avatar component using Crafatar API
 */
const PlayerAvatar = ({ uuid, username, size = 'large' }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  // Crafatar API for player renders
  const avatarUrl = `https://crafatar.com/renders/body/${uuid}?overlay=true&scale=6`;
  const headUrl = `https://crafatar.com/avatars/${uuid}?overlay=true&size=128`;

  const handleLoad = () => {
    setImageLoaded(true);
  };

  const handleError = () => {
    setImageError(true);
    setImageLoaded(true);
  };

  return (
    <motion.div
      className={`player-avatar ${size}`}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.4 }}
    >
      <div className="avatar-container">
        {!imageLoaded && (
          <div className="avatar-skeleton animate-shimmer"></div>
        )}

        {!imageError ? (
          <motion.img
            src={avatarUrl}
            alt={`${username}'s skin`}
            className={`avatar-image ${imageLoaded ? 'loaded' : ''}`}
            onLoad={handleLoad}
            onError={handleError}
            initial={{ opacity: 0 }}
            animate={{ opacity: imageLoaded ? 1 : 0 }}
            transition={{ duration: 0.3 }}
          />
        ) : (
          <img
            src={headUrl}
            alt={`${username}'s head`}
            className="avatar-image avatar-fallback loaded"
          />
        )}

        <div className="avatar-glow"></div>
      </div>

      <div className="avatar-base"></div>
    </motion.div>
  );
};

export default PlayerAvatar;
